import React, { useEffect } from "react"
import {
  generatePath,
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom"
import { observer, useLocalObservable } from "mobx-react"
import { Flex, Form } from "antd"

import { notify } from "@src/app/components/notify"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { ConvertProcess } from "@src/pages/convert/classes/ConvertProcess"
import { ConvertForm } from "@src/pages/convert/ui/ConvertForm"
import css from "@src/pages/deposit/index.module.css"
import { ConvertsCollection } from "@src/pages/transactionsSwap/classes/ConvertsCollection"
import { SwapTable } from "@src/pages/transactionsSwap/ui/SwapTable"
import { catchErrors } from "@src/shared/api"
import { useCatchFormErrors } from "@src/shared/form/base_error"

export const ConvertPage = observer(() => {
  const [form] = Form.useForm()
  const converts = useLocalObservable(() => new ConvertsCollection())
  const [query, setQuery] = useSearchParams()

  const nav = useNavigate()
  const currencyQuery = query.get("currency")
  const modeQuery = query.get("mode") === "to" ? "to" : "from"

  const process = useLocalObservable(() => new ConvertProcess(form, modeQuery))

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", left: 0, top: 0 }) // или 'auto' — без анимации
  }, [])

  useEffect(() => {
    if (!currencyQuery) {
      process.selectMaxBalanceCurrency()

      return
    }

    const setFrom = () => {
      process.setCurrencyFrom(currencyQuery)
      form.setFieldValue("currencyFrom", currencyQuery)
    }

    const setTo = () => {
      process.setCurrencyTo(currencyQuery)
      form.setFieldValue("currencyTo", currencyQuery)
    }

    if (modeQuery === "from") setFrom()
    else setTo()
  }, [currencyQuery, process.currencies])

  const onSubmit = async () => {
    return process
      .convert()
      .then((data) => {
        notify.success("Convert request sent")

        process.resetState()

        if (data) {
          nav(generatePath(paths.swapDetails, { id: data.id! }))
        }
      })
      .catch((e) => {
        catchErrors(e)
      })
  }

  const { submit } = useCatchFormErrors(form, onSubmit)

  return (
    <DefaultPageLayout
      hideBack
      isLoading={process.currencyLoading}
      title="Swap"
    >
      <Flex gap={32} vertical>
        <ConvertForm
          form={form}
          mode={modeQuery}
          process={process}
          submit={submit}
        />

        <Flex gap={16} vertical>
          <Flex
            align="center"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <span className={css.description}>History</span>
            <Link
              id="GENERATED_ID_SWAP_LINK_ALL_TRANSACTIONS_1"
              to={`${paths.transactions}?tab=sw`}
            >
              All Swaps
            </Link>
          </Flex>
          <SwapTable collection={converts} replace></SwapTable>
        </Flex>
      </Flex>
    </DefaultPageLayout>
  )
})
